// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bold[data-v-77f9aa97]{font-family:SFProDisplay-Medium,sans-serif;margin:0}.header[data-v-77f9aa97]{font-size:17px;line-height:22px}.view[data-v-77f9aa97]{font-size:14px;font-size:clamp(14px,3.86vw,22px);line-height:18px;line-height:1.2;text-align:right}.el-row[data-v-77f9aa97]{align-items:center;margin:8px 0}", ""]);
// Exports
module.exports = exports;
